import API from './apiConfig';

export const getAttendance = async (course) => {
    try {
        const response = await API.get(`/sessions/${course}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching attendance:', error);
        throw error;
    }
};

export const updateAttendance = async (sessionId, isPresent) => {
    try {
        const id = localStorage.getItem("participant_id")
            ? JSON.parse(localStorage.getItem("participant_id"))
            : "0000";
        const response = await API.put(`/attendance/${id}/${sessionId}`,{status: isPresent});
        return response.data;
    } catch (error) {
        console.error('Error updating attendance:', error);
        throw error;
    }
};

export const getAttendanceStats = async () => {
    try {
        const id = localStorage.getItem("participant_id")
            ? JSON.parse(localStorage.getItem("participant_id"))
            : "0000";
        const response = await API.get(`/attendance_stats/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching attendance stats:', error);
        throw error;
    }
};